import { clamper } from './utils/clamper';
import { tryParseInt } from './utils/tryParseInt';
export function quantitySelector({ value, max }) {
    const clamp = clamper(1, max || 99);
    function sanitizeValue(strValue, fallbackValue) {
        const sanitized = strValue.replace(/\D+/, '');
        return clamp(tryParseInt(sanitized, fallbackValue));
    }
    return {
        value,
        disabled: false,
        previousValue: -1,
        $el: {},
        $watch: (field, callback) => { },
        init() {
            this.value = tryParseInt(this.$el.parentNode.dataset.value, value || 1);
            this.previousValue = this.value;
            this.$watch('value', (newValue) => {
                const value = tryParseInt(newValue, -1);
                if (value > -1 && this.previousValue !== value) {
                    this.$el.parentNode.dispatchEvent(new CustomEvent('value-updated', { detail: value }));
                    this.previousValue = value;
                }
            });
        },
        onDec() {
            this.value = clamp(this.value - 1);
        },
        onInc() {
            this.value = clamp(this.value + 1);
        },
        onInput(event) {
            this.value = sanitizeValue(event.target.value, this.value);
        },
        onBlur(event) {
            this.value = clamp(event.target.value);
        },
        onDisable(eventData) {
            this.disabled = eventData.disabled;
        },
    };
}
;
